<div class="shift-compliance-container">
	<div
		class="
			d-flex
			flex-column flex-lg-row
			justify-content-between
			align-items-center
		"
	>
		<img
			class="shift-compliance-left"
			src="../assets/img/digital-core.svg"
			alt=""
		/>

		<div class="shift-compliance-right">
			<h1 class="shift-compliance-header">
				The Digital Core <br class="d-none d-sm-block" />
				for Government Compliance
			</h1>
			<p class="shift-compliance-para mt-4">
				Achieve a Continuous Authorization to
				<br class="d-none d-sm-block" />
				Operate <strong style="color: #f3931f">(cATO)</strong> with
				RegScale.
			</p>
			<a href="https://go.regscale.com/RegScale-Create-Account">
				<button class="mt-4 shift-compliance-btn bg-white py-2 px-4">
					Find Out How
					<i class="ml-2 fas fa-long-arrow-alt-down"></i></button
			></a>
		</div>
	</div>
</div>
